export { default } from "./table";
